import {Injectable} from '@angular/core';
import {ApiServiceProvider} from "../api-service/api-service";

@Injectable()
export class FtueServiceProvider {

    constructor(public apiService: ApiServiceProvider) {
    }

    public getTutorial(userId) {
        return this.apiService.get('/users/' + userId + '/tutorial');
    }
    
    public setTutorial(userId) {
        return this.apiService.put('/users/' + userId + '/tutorial', {"tutorial": true});
    }
}





// WEBPACK FOOTER //
// ./src/providers/ftue-service/ftue-service.ts